import * as Cesium from 'cesium';
import BaseLayer from "./baseLayer";
import CONSTANTS from "../constants";
/**
 *仓库物资图层
 */
export default class StoreLayer extends BaseLayer{

    constructor(options= {}){
        options.layerName=options.layerName||CONSTANTS.LAYER.STORE;//图层名
        super(options);
    }

    addEntities(data){
        let self=this;
        self.clearLayer();
        data.forEach((obj) =>{
            let item={...obj};
            item.layerName=self.layerName;
            if(item.longitude&&item.latitude){
                let entity=new Cesium.Entity({
                    position: Cesium.Cartesian3.fromDegrees(item.longitude,item.latitude, CONSTANTS.ALTITUDE),
                    name: item.name,
                    id:item.id,
                    attributes:item,
                    //立广告牌
                    billboard :{
                        image : "/static/imgs/map/store.png",
                        show : true,
                        width : 32,
                        height : 38,
                        pixelOffset:new Cesium.Cartesian2(0, 0),
                        heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
                    },
                    label:{
                        text : item.name,
                        font: "14px Helvetica",
                        fillColor: Cesium.Color.WHITE,
                        outlineColor: Cesium.Color.BLACK,
                        outlineWidth: 4,
                        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                        showBackground : false,
                        pixelOffset:new Cesium.Cartesian2(0, 28),
                        heightReference:Cesium.HeightReference.CLAMP_TO_GROUND
                    }
                });
                self.dataSource.entities.add(entity);
            }
        });

    }
};
